import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import { Button } from './styles';

function DropdownButton(_ref) {
  var showMoreInfo = _ref.showMoreInfo,
      handleShowInfo = _ref.handleShowInfo,
      children = _ref.children,
      elementId = _ref.elementId;
  return /*#__PURE__*/_jsx(Button, {
    "data-active": showMoreInfo,
    "data-elementid": elementId,
    onClick: handleShowInfo
  }, void 0, children);
}

DropdownButton.defaultProps = {
  elementId: null
};
export default /*#__PURE__*/memo(DropdownButton);